import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=dd5c6c54&scoped=true"
import script from "./AppLink.vue?vue&type=script&lang=js"
export * from "./AppLink.vue?vue&type=script&lang=js"
import style0 from "./AppLink.vue?vue&type=style&index=0&id=dd5c6c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5c6c54",
  null
  
)

export default component.exports